forms-destroy
  .row.mt-5.btn-wrap(class="{hide: isShow}")
    .col-12.text-right
      span.btn.btn-sm.btn-outline-danger.icon-btn(onClick="{onClickDestroy}")
        i.feather.icon-trash
  .row.form-wrap.mt-5(class="{show: isShow}")
    .alert.alert-danger
      i.feather.icon-alert-triangle
      | &nbsp;{ this.locale().attention }
    form.form(action="{ opts.action }" onSubmit="{ this.onSubmit }")
      .text-right
        inputs-without-label-submit-to-destroy(tag-scope="{ this.tagScope }.inputs.submit")
  script(type="typescript").
    this.mixin('forms.destroy');
  style(scoped).
    .form-wrap {
      display: none;
    }
    .show.form-wrap {
      display: block;
    }
    .btn-wrap {
      display: block;
    }
    .btn-wrap.hide {
      display: none;
    }
